<div>
  <span class="text-primary cursor-pointer leading-[42px]" nz-dropdown [nzDropdownMenu]="menu" [nzClickHide]="false">
    + {{ "automation-message-rules_html_limit_add_a_limit" | translate }}
  </span>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      @for (item of listOfLimitOption(); track $index) {
        <li nz-menu-item>
          <v4-selectable-menu-item [checked]="limitValues.has(item.value)" (click)="onToggleLimitValue(item.value)">{{
            item.label
          }}</v4-selectable-menu-item>
        </li>
      }
    </ul>
  </nz-dropdown-menu>

  <div>
    @if (limitValues.has("nights")) {
      <div class="flex flex-row items-center justify-between my-[8px]">
        <widget-nights [(value)]="nights" (valueChange)="emitValue()"></widget-nights>
        <span
          class="cursor-pointer"
          nz-icon
          nzType="close"
          nzTheme="outline"
          (click)="onToggleLimitValue('nights')"></span>
      </div>
    }
    @if (limitValues.has("no_left_review")) {
      <div class="flex flex-row items-center justify-between h-[42px] mb-[8px]">
        <span>
          {{ "Guests who have not yet left a review" | translate }}
          <!-- Guests who have not yet left a review -->
        </span>
        <span
          class="cursor-pointer"
          nz-icon
          nzType="close"
          nzTheme="outline"
          (click)="onToggleLimitValue('no_left_review')"></span>
      </div>
    }
    @if (limitValues.has("children")) {
      <div class="flex flex-row items-center justify-between h-[42px] mb-[8px]">
        <span>
          {{ "automation-message-rules_html_limit_opt_children" | translate }}
          <!-- Guests including children -->
        </span>
        <span
          class="cursor-pointer"
          nz-icon
          nzType="close"
          nzTheme="outline"
          (click)="onToggleLimitValue('children')"></span>
      </div>
    }
    @if (limitValues.has("infants")) {
      <div class="flex flex-row items-center justify-between h-[42px] mb-[8px]">
        <span>
          {{ "automation-message-rules_html_limit_opt_infants" | translate }}
          <!-- Guests including infants -->
        </span>
        <span
          class="cursor-pointer"
          nz-icon
          nzType="close"
          nzTheme="outline"
          (click)="onToggleLimitValue('infants')"></span>
      </div>
    }
    @if (limitValues.has("pets")) {
      <div class="flex flex-row items-center justify-between h-[42px] mb-[8px]">
        <span>
          {{ "automation-message-rules_html_limit_opt_pets" | translate }}
          <!-- Guests with pets -->
        </span>
        <span
          class="cursor-pointer"
          nz-icon
          nzType="close"
          nzTheme="outline"
          (click)="onToggleLimitValue('pets')"></span>
      </div>
    }
    @if (limitValues.has("booked_before_day")) {
      <div class="flex flex-row items-center justify-between h-[42px]">
        <div>
          <span>
            {{ "automation-message-rules_html_limit_who_booked" | translate }}
            <!-- Guests who booked -->
          </span>
          <nz-select
            nzSize="large"
            class="w-[140px] mx-[12px]"
            [nzOptions]="listOfConditionOption"
            [(ngModel)]="bookedBeforeDay"
            (ngModelChange)="emitValue()"></nz-select>
          <span>
            {{ "automation-message-rules_html_limit_checkin" | translate }}
            <!-- check-in -->
          </span>
        </div>
        <span
          class="cursor-pointer"
          nz-icon
          nzType="close"
          nzTheme="outline"
          (click)="onToggleLimitValue('booked_before_day')"></span>
      </div>
    }
  </div>
</div>
